"use strict";
function capitalizeWord(name) {
    return name ? name.charAt(0).toUpperCase() + name.slice(1) : null;
};

export default capitalizeWord;